import { cilLockLocked, cilUser } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CButton, CCard, CCardBody, CCardGroup, CCol, CContainer, CForm, CFormInput, CInputGroup, CInputGroupText, CRow } from "@coreui/react";
import React, { useState } from "react"
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";

const LoginScreen = () => {
    const [isSelected, setIsSelected] = useState(false);

    return (
        <React.Fragment>
            {
                !isMobile && (
                    <div style={{ height: '100vh', display: 'flex', background: '#fafdff' }}>
                        <div style={{ alignSelf: 'center', flex: 1, justifyContent: 'center' }}>
                            <img style={{ width: '100%', height: undefined, aspectRatio: 1.028868360277136 }} src={require('../../assets/images/login.png')} />
                        </div>

                        <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                            <div style={{ flex: 1, alignSelf: 'center', paddingLeft: 60, paddingRight: 60 }}>
                                <div style={{ borderRadius: 60, overflow: 'hidden', boxShadow: '0 2px 30px 0 rgba(192, 192, 192, 0.29)' }}>
                                    <div style={{ background: '#4d83d1', fontFamily: 'Roboto-Medium', color: '#fff', fontSize: 25, paddingTop: 30, paddingBottom: 30, textAlign: 'center' }}>
                                        NetBT Ticket Giriş
                                    </div>
                                    <div style={{ paddingTop: 60, paddingBottom: 60, paddingLeft: 90, paddingRight: 90, background: '#fff' }}>
                                        <div>
                                            <span style={{ display: 'block', fontFamily: 'Roboto-Regular', color: '#27348e', fontSize: 18 }}>E - posta</span>

                                            <input value='test@test.com' type={'text'} style={{ width: '100%', padding: '14px 8px 14px 8px', marginTop: 10, borderRadius: 8, background: '#f6f8fa', border: 'none', outline: 'none' }} />
                                        </div>

                                        <div style={{ marginTop: 30 }}>
                                            <span style={{ display: 'block', fontFamily: 'Roboto-Regular', color: '#27348e', fontSize: 18 }}>Parola</span>

                                            <input value='test@test.com' type={'password'} style={{ width: '100%', padding: '14px 8px 14px 8px', marginTop: 10, borderRadius: 8, background: '#f6f8fa', border: 'none', outline: 'none' }} />
                                        </div>

                                        <div style={{ display: 'flex', marginTop: 30 }}>
                                            <div className="actionIcon" onClick={() => setIsSelected(!isSelected)} style={{ alignSelf: 'center', background: isSelected ? '#44b0f3' : '#d8d8d8', width: 25, height: 25, borderRadius: 5 }}>&nbsp;</div>

                                            <div className="actionIcon" onClick={() => setIsSelected(!isSelected)} style={{ userSelect: 'none', msUserSelect: 'none', MozUserSelect: 'none', WebkitUserSelect: 'none', marginLeft: 6, lineHeight: 1.2, alignSelf: 'center', fontFamily: 'Roboto-Regular', color: '#000', fontSize: 16 }}>
                                                Beni Hatırla
                                            </div>
                                        </div>

                                        <div className="actionIcon" style={{ marginTop: 30, background: '#44b0f3', borderRadius: 8, paddingTop: 10, paddingBottom: 10, fontFamily: 'Roboto-Medium', color: '#fff', fontSize: 20, textAlign: 'center' }}>
                                            Giriş Yap
                                        </div>

                                        <div className="actionIcon" style={{ marginTop: 30, fontFamily: 'Roboto-Regular', fontSize: 18, color: '#3599ff', textAlign: 'center' }}>
                                            Şifremi Unuttum
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                isMobile && (
                    <div style={{ height: '100vh', display: 'flex', background: '#fafdff', padding: 15 }}>
                        <div style={{ alignSelf: 'center', flex: 1, borderRadius: 15, overflow: 'hidden', boxShadow: '0 2px 30px 0 rgba(192, 192, 192, 0.29)' }}>
                            <div style={{ background: '#4d83d1', fontFamily: 'Roboto-Medium', color: '#fff', fontSize: 25, paddingTop: 15, paddingBottom: 15, textAlign: 'center' }}>
                                NetBT Ticket Giriş
                            </div>

                            <div style={{ padding: 15 }}>
                                <div>
                                    <span style={{ display: 'block', fontFamily: 'Roboto-Regular', color: '#27348e', fontSize: 18 }}>E - posta</span>

                                    <input value='test@test.com' type={'text'} style={{ width: '100%', padding: '14px 8px 14px 8px', marginTop: 10, borderRadius: 8, background: '#f6f8fa', border: 'none', outline: 'none' }} />
                                </div>


                                <div style={{ marginTop: 30 }}>
                                    <span style={{ display: 'block', fontFamily: 'Roboto-Regular', color: '#27348e', fontSize: 18 }}>Parola</span>

                                    <input value='test@test.com' type={'password'} style={{ width: '100%', padding: '14px 8px 14px 8px', marginTop: 10, borderRadius: 8, background: '#f6f8fa', border: 'none', outline: 'none' }} />
                                </div>

                                <div style={{ display: 'flex', marginTop: 30 }}>
                                    <div className="actionIcon" onClick={() => setIsSelected(!isSelected)} style={{ alignSelf: 'center', background: isSelected ? '#44b0f3' : '#d8d8d8', width: 25, height: 25, borderRadius: 5 }}>&nbsp;</div>

                                    <div className="actionIcon" onClick={() => setIsSelected(!isSelected)} style={{ userSelect: 'none', msUserSelect: 'none', MozUserSelect: 'none', WebkitUserSelect: 'none', marginLeft: 6, lineHeight: 1.2, alignSelf: 'center', fontFamily: 'Roboto-Regular', color: '#000', fontSize: 16 }}>
                                        Beni Hatırla
                                    </div>
                                </div>

                                <div className="actionIcon" style={{ marginTop: 30, background: '#44b0f3', borderRadius: 8, paddingTop: 10, paddingBottom: 10, fontFamily: 'Roboto-Medium', color: '#fff', fontSize: 20, textAlign: 'center' }}>
                                    Giriş Yap
                                </div>

                                <div className="actionIcon" style={{ marginTop: 30, fontFamily: 'Roboto-Regular', fontSize: 18, color: '#3599ff', textAlign: 'center' }}>
                                    Şifremi Unuttum
                                </div>
                            </div>


                        </div>
                    </div>
                )
            }
        </React.Fragment>

    )
}

export default LoginScreen;